<div class="detail">
    <div class="key">
        {{data.name}}:
    </div>
    <div class="value">
    
        <!-- Simple -->
        <ng-container *ngIf="['Object','Object[]'].indexOf(data._type) == -1 && data.value !== undefined">
            {{formatProfileValue(data.value)}}
        </ng-container>

        <ng-container *ngIf="['Object','Object[]'].indexOf(data._type) == -1 && data.value === undefined">
            -
        </ng-container>
    
        <!-- Object -->
        <ng-container *ngIf="data._type == 'Object' && data.value !== undefined && data.fields !== undefined">
            <div class="details object">
                <ng-container *ngFor="let field of data.fields">
                    <customer-profile-object [data]="prepareField(field)"></customer-profile-object>
                </ng-container>
            </div>
        </ng-container>

        <ng-container *ngIf="data._type == 'Object' && data.value === undefined">
            -
        </ng-container>
    
        <!-- Object[] -->
        <ng-container *ngIf="data._type == 'Object[]' && data.value !== undefined && data.fields !== undefined">
            <div class="details">
                <ng-container *ngFor="let obj of data.value; index as i">
                    <div class="object">
                        <ng-container *ngFor="let field of data.fields">
                            <customer-profile-object [data]="prepareObject(field, obj)"></customer-profile-object>
                        </ng-container>
                    </div>
                </ng-container>
            </div>
        </ng-container>
    
    </div>
</div>